import { Loader2 } from "lucide-react";

import Logo from "@/components/shared/Logo";
import { useI18n } from "@/lib/i18n";

export default function RouteLoadingShell({
  title = "Loading…",
  copy = "",
}) {
  const { tx } = useI18n();

  return (
    <div className="min-h-[100dvh] flex flex-col bg-background">
      <nav className="flex items-center justify-center px-5 py-4">
        <Logo size="sm" />
      </nav>

      <div className="flex flex-1 items-center justify-center px-5 pb-24">
        <div
          role="status"
          aria-live="polite"
          className="w-full max-w-sm rounded-[2rem] border border-border bg-card/90 p-6 text-center shadow-[0_20px_80px_-40px_rgba(15,23,42,0.5)]"
        >
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Loader2 className="h-7 w-7 animate-spin" />
          </div>
          <h1 className="mt-4 font-display text-2xl font-bold">{tx(title)}</h1>
          {copy ? (
            <p className="mt-2 text-sm text-muted-foreground">{tx(copy)}</p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
